module.exports = __webpack_public_path__ + "static/media/red_girl.8f63e7a3.jpg";